import { handleMessages, load } from 'poly-eshop4/eshop/ui/js/util';
import api from 'poly-eshop4/eshop/ui/js/container';

$(document).on('click', '[data-select-greeting-card]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(this).attr('href'),
  }).done((resp) => {
    const element = $(resp).foundation();
    $('[data-greeting-card-form] textarea').trigger('keyup');
    element.foundation('open');
  });
});

$(document).on('submit', '[data-greeting-card-form]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const $reveal = $form.closest('[data-reveal]');

  const promise = api.addPosition($form, 'cart')
    .then(handleMessages)
    .then((data) => {
      setTimeout(() => $form.closest('[data-reveal]').foundation('close'), 1500);
      return data;
    });

  load($reveal, promise, {
    errorClass: 'error',
  });
});

function limitGreetingCardText(event, value) {
  const newLines = value.split('\n').length;
  if (event.keyCode === 13 && newLines >= 27) {
    return false;
  }
  return true;
}

$(document).on('keydown', '[data-greeting-card-form] textarea', function(event) {
  const change = limitGreetingCardText(event, $(this).val());
  if (!change) {
    event.preventDefault();
  }
  return change;
});

$(document).on('keyup', '[data-greeting-card-form] textarea', function() {
  const val = $(this).val();
  const c = val.length;
  const l = val.length ? val.split('\n').length : 0;

  $('[data-greeting-card-form] [data-greeting-card-counter]').text(300 - c);
  $('[data-greeting-card-form] [data-greeting-card-counter-lines]').text(27 - l);
});

// plus / minus

const PLUS_MINUS_DEBOUNCE_WAIT = 400;

const updatePosition = window.Foundation.util.debounce(($input, type = false) => {
  if (type) {
    if (type === 'shoppinglist-select') {
      $input.closest('form').submit();
    } else {
      $input.closest('[data-plus-minus-input]').find(`[data-update-${type}-position-quantity]`).trigger('blur');
    }
  } else {
    $input.closest('[data-add-cart-position]').trigger('submit.addCartPosition');
  }
}, PLUS_MINUS_DEBOUNCE_WAIT);

const removePosition = window.Foundation.util.debounce(($form) => {
  const data = $form.serializeArray();
  data.push({ name: 'calculate', value: 1 });
  if ($('[data-bind-html="cart:html"]').length) {
    data.push({ name: 'render', value: 1 });
  }

  const $item = $form.closest('[data-cart-item]');
  load(
    $form,
    $.stores.cart.post($item.attr('data-cart-item-delete-url'), data),
  );
}, PLUS_MINUS_DEBOUNCE_WAIT);

$(document).on('click', '[data-plus-minus-input] [data-operator]', function func(event) {
  event.preventDefault();

  const $button = $(this);
  const $form = $button.closest('form');
  const $item = $form.closest('[data-cart-item]');
  const $elem = $button.closest('[data-plus-minus-input]');
  const $input = $elem.find('input');
  const type = $input.attr('data-type');
  const currentVal = parseFloat($input.val());
  const operator = $button.attr('data-operator');
  const min = parseFloat($input.prop('min') || 0);
  const max = parseFloat($input.prop('max'));
  const step = parseFloat($input.prop('step') || 1);

  if (Number.isNaN(currentVal)) {
    if (operator === '+') {
      $input.val(step);
      updatePosition($input, type);
    }
  } else if (operator === '-') {
    if (currentVal - step >= min) {
      $input.val(currentVal - step);
      updatePosition($input, type);
    } else if ($item.attr('data-cart-item-delete-url')) {
      $input.val('');
      removePosition($form);
    }
  } else if (Number.isNaN(max) || currentVal + step <= max) {
    $input.val(currentVal + step);
    updatePosition($input, type);
  }
});
